// Widget scripts
import swiperWidget from './js/widgets/swiperWidget.js';
import cardWidgetHotButtons from './js/widgets/cardWidgetHotButtons.js';
import cardWidgetQuickRates from './js/widgets/cardWidgetQuickRates.js';
import cardWidgetSEOText from './js/widgets/cardWidgetSEOText.js';
import cardWidgetVideoImage from './js/widgets/cardWidgetVideoImage.js';
import * as socialNetworkWidget from './js/widgets/socialNetworkWidget.js';




// Custom theme scripts
import './js/localjs.js';



// Initialize homepage widgets
if (window.location.pathname === '/') {
  $(document).ready(function() {
    swiperWidget();  
    cardWidgetHotButtons(); 
    cardWidgetQuickRates();
    cardWidgetSEOText();
    cardWidgetVideoImage();
  });
  
  $(window).load(function() {
    socialNetworkWidget.instafeed(true);
  });
}
